<script setup lang="ts">
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import { IProfile } from '@/interfaces';
import Checkbox from '@/components/shared/Checkbox.vue';

interface Props {
  profile: IProfile;
  isSelected?: boolean;
  size?: 'small' | 'large';
}

withDefaults(defineProps<Props>(), {
  size: 'small',
});

const emit = defineEmits(['select-profile']);
</script>

<template>
  <div
    class="profile flex flex-col items-center justify-center rounded-2xl relative"
    :class="[
      {
        'bg-darkOcean-100 border-4 border-darkOcean-600': isSelected,
        'bg-neutral-0 border-1 border-neutral-300': !isSelected,
      },
      size,
    ]"
    @click="emit('select-profile', profile)"
  >
    <Checkbox
      v-if="isSelected"
      :checked="true"
      class="absolute top-0 right-0 mr-2 mt-2"
    />

    <img
      class="profileImage rounded-full shadow-smallBottom object-cover mb-4 border-neutral-0"
      :class="size"
      :src="getOptimizedImageSrc(profile.displayImage, 'small')"
    />

    <p class="text-2xl b500 text-center">
      {{ profile.displayName }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.profile {
  &.small {
    height: 204px;
  }

  &.large {
    height: 244px;
  }

  .profileImage {
    &.small {
      width: 114px;
      height: 114px;
      border-width: 6px;
    }

    &.large {
      width: 140px;
      height: 140px;
      border-width: 6px;
    }
  }
}
</style>
